import { BASE_API_URL } from '@env';
import { useMutation, useQueryClient } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { DeleteEventResponse, DeleteEventRequest } from '~types/api/event';

export function useReviveEvent() {
  const queryClient = useQueryClient();

  return useMutation<DeleteEventResponse, Error, DeleteEventRequest>(
    async (requestData: DeleteEventRequest) => {
      const token = useUserStore.getState().token;
      console.log('Auth token:', token);
      const url = `${BASE_API_URL}events/revive/${requestData.event_id}`;
      console.log('URL:', url);

      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      const responseBody = await response.text();
      console.log('Response status:', response.status);
      console.log('Response body:', responseBody);

      if (!response.ok) {
        throw new Error('Failed to Revive the event');
      }

      return { details: 'Event Revived successfully' };
    },
    {
      onSuccess: () => {
        console.log('Event Revived successfully, refetching events');
        queryClient.refetchQueries('eventsAll');
      },
    },
  );
}
